import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import { cloneDeep } from "lodash";

function MomSysOrderBuyerExcelUploadButton ( props ) {

    const { t } = useTranslation();

    const { id, schema, refresh, onSuccess, createButtonName, customizeErrorMsgCallback, modifyUrlCallback, ...others } = props;

    const [ open, setOpen ] = useState(false);

    const [ modifiedSchema, setModifiedSchema ] = useState();

    useEffect(() => {

        let clonedSchema = cloneDeep ( schema );

        for (const column of clonedSchema.columns) {
        
            switch (column.name) {

                case "companyCode": 
                case "deliveryCompanyCode":
                case "paymentCompanyCode":
                case "orderBuyerDate":
                case "orderBuyerDocExcel":

                    column.required = true;
                    column.hideInForm = false;

                    break;

                default:

                    column.hideInForm = true;

                    break;
            }

        }

        setModifiedSchema(clonedSchema);

    }, [schema]);

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        if ( refresh ) {

            refresh.refresh ();

        }

    };

    return (

        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} createButtonName ={createButtonName} {...others} />
            <AutoFormDialog
                id={id+"create-dialog"}
                mode="create"
                formId={id+"create-form"}
                title={ schema ? t ( `dialog.title.${schema.name}.allCreate` ) : "" }
                schema={modifiedSchema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                modifyUrlCallback={modifyUrlCallback}
                noKeepOpen={true}
            />
        </>

    );
}

export default MomSysOrderBuyerExcelUploadButton;

